import { render } from "./BaseResponsiveImage.vue?vue&type=template&id=62b6934e"
import script from "./BaseResponsiveImage.vue?vue&type=script&lang=js"
export * from "./BaseResponsiveImage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__